var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowEmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.294113,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#0F6540"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16038 11.4045L5.28921 13.157L6.41751 11.4045H5.77428V9.76569H4.80361V11.4045H4.16038Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16529 12.7191L8.29412 14.4715L9.42242 12.7191H8.77919V9.76569H7.80851V12.7191H7.16529Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1702 11.4045L11.299 13.157L12.4273 11.4045H11.7841V9.76569H10.8134V11.4045H10.1702Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5876 8.89054H12.4257C13.4458 8.89054 14.2726 8.03343 14.2726 7.04312C14.2726 6.0528 13.4935 5.24452 12.5144 5.19782C12.3493 4.10508 11.4068 3.26761 10.2678 3.26761C9.97595 3.26761 9.6968 3.32334 9.44046 3.42364C9.14061 2.51983 8.28881 1.86758 7.28417 1.86758C6.02956 1.86758 5.01218 2.88443 5.01218 4.13958C5.01218 4.22396 5.01695 4.30728 5.02598 4.38901C4.88427 4.36141 4.7378 4.34655 4.5876 4.34655C3.33299 4.34655 2.31561 5.36394 2.31561 6.61855C2.31561 7.87316 3.33246 8.89054 4.5876 8.89054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowEmission);
export default __webpack_public_path__ + "static/media/low-emission.e0619e840205009214655caba275cf06.svg";
export { ForwardRef as ReactComponent };